import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './website/components/common/ScrollToTop';
import App from './App';
import ReloadPrompt from './components/ReloadPrompt';
import { initializeAutoUpdate } from './auto-update';
import { HelmetProvider } from 'react-helmet-async';

function Root() {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      const prev = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
      return () => { window.history.scrollRestoration = prev; };
    }
  }, []);

  useEffect(() => initializeAutoUpdate(), []);

  return (
    <HelmetProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <App />
        <ReloadPrompt />
      </Router>
    </HelmetProvider>
  );
}

export default Root; 